@if (pageDataProvince()?.content?.length) {
  <div class="row">
    <div class="col-12">
      <ngb-pagination class="d-flex justify-content-center"
                      [maxSize]="5"
                      [rotate]="true"
                      [ellipses]="false"
                      [boundaryLinks]="true"
                      [page]="pageDataProvince()?.number + 1"
                      (pageChange)="searchProvince($event)"
                      [pageSize]="pageDataProvince()?.size"
                      [collectionSize]="pageDataProvince()?.totalElements"></ngb-pagination>
    </div>
  </div>
}

<div class="table-responsive">
  <table class="table table-striped table-bordered caption-top">
    <thead>
    <tr>
      <th nowrap class="text-center" rowspan="2">รหัสหน่วยบริการประจำ</th>
      <th nowrap class="text-start" rowspan="2">ชื่อหน่วยบริการประจำ</th>
      <th nowrap class="text-center" rowspan="2">จังหวัด</th>
      <th nowrap class="text-center" colspan="3">จำนวนประชากร</th>
      <th nowrap class="text-center" colspan="3">โมเดล 1</th>
      <th nowrap class="text-center" colspan="3">โมเดล 2</th>
      <th nowrap class="text-center" colspan="3">โมเดล 4</th>
    </tr>
    <tr>
      <th nowrap class="text-center" scope="col">{{ prevMonth() }}</th>
      <th nowrap class="text-center" scope="col">{{ currentMonth() }}</th>
      <th nowrap class="text-center" scope="col">ส่วนต่าง</th>
      <th nowrap class="text-center" scope="col">{{ prevMonth() }}</th>
      <th nowrap class="text-center" scope="col">{{ currentMonth() }}</th>
      <th nowrap class="text-center" scope="col">ส่วนต่าง</th>
      <th nowrap class="text-center" scope="col">{{ prevMonth() }}</th>
      <th nowrap class="text-center" scope="col">{{ currentMonth() }}</th>
      <th nowrap class="text-center" scope="col">ส่วนต่าง</th>
      <th nowrap class="text-center" scope="col">{{ prevMonth() }}</th>
      <th nowrap class="text-center" scope="col">{{ currentMonth() }}</th>
      <th nowrap class="text-center" scope="col">ส่วนต่าง</th>
    </tr>
    </thead>
    <tbody>
      @for (item of pageDataProvince()?.content; let i = $index; track item) {
        <tr>
          <td class="text-center fw-semibold text-muted">{{ item.hmainOpCode || '-' }}</td>
          <td>{{ item.hmainOp?.displayNameWithoutHcode || '-' }}</td>
          <td>{{ item.purprovince || '-' }}</td>
          <td class="text-end">{{ (item.prevTotalMan || 0) | number }}</td>
          <td class="text-end">{{ (item.currTotalMan || 0) | number }}</td>
          <td class="text-end">{{ (item.diffTotalMan || 0) | number }}</td>
          <td class="text-end">{{ (item.prevPointModel1 || 0) | number }}</td>
          <td class="text-end">{{ (item.currPointModel1 || 0) | number : '1.4-4' }}</td>
          <td class="text-end">{{ (item.diffPointModel1 || 0) | number }}</td>
          <td class="text-end">{{ (item.prevPointModel2 || 0) | number }}</td>
          <td class="text-end">{{ (item.currPointModel2 || 0) | number : '1.4-4' }}</td>
          <td class="text-end">{{ (item.diffPointModel2 || 0) | number }}</td>
          <td class="text-end">{{ (item.prevPointModel4 || 0) | number }}</td>
          <td class="text-end">{{ (item.currPointModel4 || 0) | number : '1.4-4' }}</td>
          <td class="text-end">{{ (item.diffPointModel4 || 0) | number }}</td>
        </tr>
      } @empty {
        <tr>
          <td colspan="15">
            <app-not-found></app-not-found>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div class="row">
  <div class="col-12">
    <ngb-pagination class="d-flex justify-content-center"
                    [maxSize]="5"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    [page]="pageDataProvince()?.number + 1"
                    (pageChange)="searchProvince($event)"
                    [pageSize]="pageDataProvince()?.size"
                    [collectionSize]="pageDataProvince()?.totalElements"></ngb-pagination>
  </div>
</div>
